<template>
  <div class="page">
    <div class="page-title">产品身份卡</div>

    <div class="info-card">
      <div class="img-block" v-if="pageData.photo">
        <img class="wh100" :src="pageData.photo" alt="">
      </div>
      <div class="row"><label>产品名称</label><span>{{pageData.product }}</span></div>
      <!-- <div class="row"><label>产品规格</label><span>{{ pageData.productiondate }}</span></div> -->
      <!-- <div class="row"><label>生产日期</label><span>{{ pageData.productiondate || '' }}</span></div> -->

      <div class="code-row">
        <span>防伪查询码&emsp;&emsp;&emsp;{{ pageData.tCode }}</span>
   
        <div size="mini" class="code" type="primary" @click="copyCode">复制</div>
      </div>

      <!-- <div class="tag" v-if="pageData.validateName=='正品'">官方正品 · 安全可追溯</div>
      <div class="tag" v-else>编码异常,请联系公司客服</div> -->
      <div class="tag" v-if="validate=='不是正品'">编码异常,请联系公司客服</div>
      <div class="tag" v-else>官方正品 · 安全可追溯</div>


    </div>
  </div>
</template>

<script>
// 只在当前组件引入 axios，创建独立实例
import axios from 'axios'
import http from "../common/http.js";
export default {
  name: 'ykyCodeIndex',
  data() {
    return {
      pageData:{},
      validate:''
    }
  },
  mounted() {
    let {tCode,s,validate}=this.$route.query
    console.log(this.$route.query,'this.$route.query');
    this.validate=validate
    if(tCode){
      sessionStorage.setItem('currentTCode',tCode)
       
    }
    if(s){
      sessionStorage.setItem('t',s)
       
    }
   this.getProduct()
  },
  methods: {
    async getProduct(){
      try {
        // let tCode = sessionStorage.getItem('currentTCode')

        // ======================
        // 关键：单独创建 axios 实例（不影响全局！）
        // ======================
        // const instance = axios.create({
        //   baseURL: 'https://trace.hkaspire.cn/' // 你要的独立域名
        // })

        // // 使用这个独立实例发请求
        // let res = await instance.get(`/Inspection/GetQualityMobileGoods?code=${tCode}`)
        // // let res= await http.get(`/goods/public/sku?barcode=${barcode}`)
        // console.log('请求成功', res)
        // // 赋值数据到页面
        // this.pageData = res.data || {}
        
        let barcode = this.$route.query.barcode || sessionStorage.getItem('barcode')
        let productiondate = this.$route.query.productiondate || sessionStorage.getItem('productiondate')
        let tCode = this.$route.query.tCode || sessionStorage.getItem('tCode')


        if(barcode){
          let res = await http.get(`/goods/public/sku?barcode=${barcode}`)
          console.log(res,'res商品==');
          const data = res.data || {};
          let { _id, product } = data;
          this.pageData = {
            ...data,
            barcode,
            productiondate,
            tCode,
            product: product || this.$route.query.name
          };
          // 响应式赋值
          // this.pageData.photo = photo
          // this.$set(this.pageData, 'photo', photo)
          // this.$set(this.pageData, 'product', product)

          sessionStorage.setItem('currentProductId',_id)  //_id 为skuid

          sessionStorage.setItem('barcode',barcode)
          sessionStorage.setItem('productiondate',productiondate || '')
          sessionStorage.setItem('tCode',tCode)

          // this.pageData.name = res.data.name
        }

      } catch (error) {
        console.log('请求失败', error)
      }
    },
    // 复制功能
    copyCode() {
      const input = document.createElement('input')
      input.value = this.pageData.tCode
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$toast('防伪码复制成功')
    }
  }
}
</script>

<style scoped>
/* 页面容器 */
.page {
  padding: 24px 16px;
  background: #f7f8fc;
  min-height: 100vh;
}

/* 标题 + 伪元素左侧竖线（核心！） */
.page-title {
  position: relative;
  font-size: 20px;
  font-weight: 700;
  color: #1d2129;
  margin-bottom: 20px;
  padding-left: 12px;
  letter-spacing: 0.5px;
}
.page-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 16px;
  background-color: #2E5CFA;
  border-radius: 2px;
}

/* 内容卡片 */
.info-card {
  background: #fff;
  border-radius: 18px;
  padding: 24px;
  box-shadow: 0 4px 18px rgba(0, 30, 120, 0.05);
}

/* 图片区域 */
.img-block {
  width: 100%;
  height: auto;
  border-radius: 14px;
  margin-bottom: 20px;
}
.wh100{
  width: 100%;
  height: auto;
}

/* 行样式 */
.row {
  display: flex;
  padding: 14px 0;
  border-bottom: 1px solid #f2f3f8;
  font-size: 15px;
}
.row:last-child {
  border-bottom: none;
}

/* 标签 */
label {
  width: 95px;
  color: #646c80;
  font-weight: 500;
}

/* 内容 */
span {
  color: #252a37;
  flex: 1;
}

/* 防伪码行 */
.code-row {
  width: 100%;
  justify-content: space-between;
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.code {
  color: #2E5CFA;
  font-weight: 600;
  letter-spacing: 0.5px;
  cursor: pointer;
}

/* 正品标签 */
.tag {
  margin-top: 20px;
  text-align: center;
  color: #2E5CFA;
  font-size: 14px;
  font-weight: 500;
  background: rgba(46, 92, 250, 0.08);
  padding: 9px 14px;
  border-radius: 10px;
}
</style>